import { gql } from "@apollo/client"
import { useQuery, UseQueryOptions } from "@oysterhr/core"
import { VariableCompensationFragment } from "~/shared/fragments/VariableCompensationFragment"
import { Engagement } from "@oysterhr/schema"

const VariableCompensationsQuery = gql`
  query EngagementVariableCompensationsQuery($engagementId: ID!) {
    engagement(engagementId: $engagementId) {
      id
      variableCompensations {
        nodes {
          ...VariableCompensationFragment
        }
      }
    }
  }
  ${VariableCompensationFragment}
`

export const useVariableCompensationsQuery = (
  engagementId: string,
  options?: UseQueryOptions<{ engagement: Engagement }, { engagementId: string }>,
) => {
  const { data, ...rest } = useQuery(VariableCompensationsQuery, {
    variables: { engagementId },
    ...options,
  })

  return {
    engagement: data?.engagement,
    ...rest,
  }
}
